import React, { useEffect, useMemo, useRef } from "react";

import { PopoverFilterList } from "@/components/molecules/PopoverFilterList";
import { type IWidgetFilterItem, useWidgetFiltersController } from "./useWidgetFiltersController";
import { Widget } from "@/modules";
import { ITableWidget } from "../table";
import { usePopoverController } from "@/components/molecules/Popover";
import { useWidgetProducts } from "./useWidgetProducts";



export interface IProductFilterProps {
    controller: ReturnType<typeof useWidgetFiltersController>;
    widget: Widget;
    widgetData: ITableWidget;
}

export const ProductFilter: React.FC<IProductFilterProps> = ({ controller, widget, widgetData }) => {
    const { setSelectedProducts, selectedProducts } = controller;
    const popoverController = usePopoverController();
    const firstLoad = useRef<boolean>(true);
    const products = useWidgetProducts(widget);

    const hasData = useMemo(() => Boolean(widgetData?.data?.rows?.length !== 0), [widgetData?.data?.rows?.length]);

    const handleSelectionChange = (newSelectedProducts: IWidgetFilterItem[]) => {
        if (newSelectedProducts.length) {

            setSelectedProducts(newSelectedProducts);
        }
    };


    useEffect(() => {
        popoverController.close();
    }, [hasData]);

    useEffect(() => {
        if (!firstLoad.current) return;
        if (!selectedProducts || selectedProducts.length === 0) {
            setSelectedProducts(products, true);
        }
        firstLoad.current = false;
    }, [products, setSelectedProducts, selectedProducts]);



    if (!products.length || !widget?.filterByProduct || ((products.length === selectedProducts.length) && !Boolean(widgetData?.data))) {
        return null;
    }


    return (
        <PopoverFilterList
            items={products}
            selectedItems={selectedProducts}
            onSelectionChange={handleSelectionChange}
            triggerLabel={`Products: ${selectedProducts.length} selected`}
            width="w-50"
            popoverController={popoverController}
        />
    );
};
